import { createStore, combineReducers } from "redux";
import {
  activeMenuItemReducer,
  solveProblemReducer
} from "./reducers/activeItemReducer";

const rootReducer = combineReducers({
  activeMenuItem: activeMenuItemReducer,
  solveProblem: solveProblemReducer
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;